import React from 'react';
import Home from './components/Home';
import Header from './components/Header';
import Nav from './components/Nav';
import About from './components/About';
import Photography from './components/Photography';
import Services from './components/Services';
import Contact from './components/Contact';
import { BrowserRouter as Router } from 'react-router-dom';
import Footer from "./components/Footer";

const App = () => {
  return (
    <div className='bg-site bg-no-repeat bg-cover overflow-hidden'>
      <Router>
      <Header />
      <Home />
      <Nav />
      <Photography />
      <Services />
      <Contact />
      <About />
      <Footer />
      </Router>
    </div>
  );
};

export default App;
